import { ApiModel } from '@nodal/api';

export const sortIntroductionsByDate = (
  array: Array<ApiModel.IntroductionFull>,
) => array.sort((a, b) => (new Date(a.updated) > new Date(b.updated) ? -1 : 1));
